import dayjs from "dayjs";

export const calculateMaxLeaveRange = ({ startDate, selectedLeave }) => {
  if (!startDate || !selectedLeave) return null;

  const start = dayjs(startDate);

  // Determine if start is in current month
  const isSameMonthAsToday = start.isSame(dayjs(), "month");

  // Quotas
  let currentMonthQuota = isSameMonthAsToday
    ? selectedLeave.remaining_this_month
    : selectedLeave.total_this_month;

  const nextMonthQuota = selectedLeave.total_this_month;

  // Days left in current month (including start date)
  const daysLeftInMonth = start.endOf("month").diff(start, "day") + 1;

  let totalAllowedDays;

  if (currentMonthQuota <= daysLeftInMonth) {
    // Fully within current month
    totalAllowedDays = currentMonthQuota;
  } else {
    // Spill into next month
    const spill = currentMonthQuota - daysLeftInMonth;

    totalAllowedDays = daysLeftInMonth + Math.min(spill, nextMonthQuota);
  }

  // Apply constraints
  if (selectedLeave.at_a_time_max_limit) {
    totalAllowedDays = Math.min(
      totalAllowedDays,
      selectedLeave.at_a_time_max_limit,
    );
  }

  if (selectedLeave.remaining_days) {
    totalAllowedDays = Math.min(totalAllowedDays, selectedLeave.remaining_days);
  }

  // Ensure minimum
  if (selectedLeave.at_a_time_min_limit) {
    totalAllowedDays = Math.max(
      totalAllowedDays,
      selectedLeave.at_a_time_min_limit,
    );
  }

  return {
    maxDate: start.add(totalAllowedDays - 1, "day").toDate(),
    totalAllowedDays,
  };
};
